import { Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { PageHeader } from '../ui/page'
import { QuoteConversations } from './quote-conversations'

/** Every email with the customer about this quote and its invoices (USA-1094). */
export function QuoteEmailsPage({ quoteId }: { quoteId: string }) {
  return (
    <div className="mx-auto w-full max-w-6xl">
      <PageHeader
        actions={
          <Button asChild size="sm" variant="outline">
            <Link params={{ quoteId, stage: 'equipment' }} to="/quotes/$quoteId/workflow/$stage">
              <ArrowLeft aria-hidden="true" />
              Back to quote
            </Link>
          </Button>
        }
        title="Customer emails"
      />
      <QuoteConversations quoteId={quoteId} title="Conversations" />
    </div>
  )
}
